<main class="app-layout">
  <!-- Header Section starts here -->
  <div
    class="header_layout"
    *ngIf="redirectPath != '/signin' && redirectPath != '/'"
  >
    <dmp-header></dmp-header>
  </div>
  <!-- Header Section ends here -->

  <!-- Main Section starts here -->

  <div class="main_layout_container">
    <!-- SideBar Section -->

    <div class="side-menu">
      <dmp-sidebar style="width: 100%"></dmp-sidebar>
    </div>

    <!-- Main Container section -->

    <div class="main_layout_side_container">
      <div
        class="mt-3"
        *ngIf="redirectPath != '/signin' && redirectPath != '/'"
      >
        <!-- Breadcrumb section -->

        <app-breadcrumb></app-breadcrumb>
      </div>

      <ng-container *ngIf="!whiteLabelMode; else kronyx">
        <ngx-spinner
          bdColor="rgba(50, 50, 50, 0.4)"
          size="default"
          color="orange"
          type="ball-clip-rotate"
        >
        </ngx-spinner>
      </ng-container>

      <ng-template #kronyx>
        <ngx-spinner
          template="<img src='assets/kronyx/kronyx-loader.gif' class='kronyx-loader'>"
        >
        </ngx-spinner>
      </ng-template>

      <router-outlet></router-outlet>

      <!-- Chat Bot Section starts here -->

      <ng-container
        *ngIf="
          ((chatBotEnabled && apnxEnabled) || ispfmRole) &&
          uriFirstIndex != 'adsp' &&
          uriFirstIndex != 'bdsp' &&
          !whiteLabelMode
        "
      >
        <div
          [ngClass]="{
            'chatbot-icon-wrapper': true,
            minimized: minimizeChatIcon
          }"
        >
          <mat-icon
            *ngIf="!minimizeChatIcon"
            class="cursor_pointer me-3"
            (click)="minimizeChatIcon = true"
            >remove_circle_outline</mat-icon
          >
          <mat-icon
            *ngIf="minimizeChatIcon"
            class="cursor_pointer me-3"
            (click)="minimizeChatIcon = false"
            >add_circle_outline</mat-icon
          >
          <img
            [src]="imgPath"
            class="chatbot-icon-img"
            (click)="isDisplayChatPanel()"
          />
        </div>

        <ng-container *ngIf="isShowChatPanel">
          <app-chatbot-panel
            [globalParams]="params"
            [userRole]="userRole"
            [isShowChatPanel]="isShowChatPanel"
            [minimizeChatPanel]="minimizeChatPanel"
            (toggleChatPanel)="isDisplayChatPanel()"
            (minimizePanel)="minimizePanel()"
          >
          </app-chatbot-panel>
        </ng-container>
      </ng-container>
      <!-- Chat Bot Section ends here -->
    </div>
  </div>
  <!-- Main Section ends here -->
</main>
